import { v4 as uuid } from 'uuid';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { actions } from 'react/api/actions/eventHttpActionLogs';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

const {
  fetchEventHttpActionLogs,
  updateEventHttpActionLogs,
  setIsLoadingEventHttpLogs,
  clearEventHttpActionLogs
} = actions;

const parseData = data => data.map(item => ({
  ...item,
  id: uuid(),
  action: 'POST Request'
}));

function showLoading() {
  App.Forms.EventLogHttpAction?.filterBuilder?.loading?.init();
  App.Forms.EventLogHttpAction?.filterBuilder?.loading?.show();
}

function hideLoading() {
  App.Forms.EventLogHttpAction?.filterBuilder?.loading?.hide();
}

function* updateEventHttpActionLogsData({
  data,
  shouldClearData,
  shouldClearBeforeUpdateLogs
}) {
  if (shouldClearData) {
    yield put({
      type: clearEventHttpActionLogs
    });
  } else {
    yield put({
      type: updateEventHttpActionLogs,
      payload: {
        data,
        shouldClearBeforeUpdateLogs
      }
    });
  }
}

function* fetchEventHttpActionLogsSaga(action) {
  const { filtersPayload } = action.payload;

  const encodedURL = encodeURI('/EventLogAction/Logs');
  const requestBody = Object.assign({
    eventKey: "HTTP_REQUEST",
    page: 0,
    size: 51,
  }, filtersPayload);

  yield all([
    put({
      type: setIsLoadingEventHttpLogs,
      payload: {
        isLoading: true
      }
    }),
    call(showLoading)
  ]);

  const eventHttpActionLogs = yield call(defaultFetch, encodedURL, requestBody, 'POST');

  if (!eventHttpActionLogs?.error) {
    const shouldClearData = requestBody.page === 0 && !eventHttpActionLogs.length;
    const shouldClearBeforeUpdateLogs = requestBody.page === 0 && eventHttpActionLogs.length;

    yield updateEventHttpActionLogsData({
      data: parseData(eventHttpActionLogs),
      shouldClearData,
      shouldClearBeforeUpdateLogs
    });
  }

  yield all([
    put({
      type: setIsLoadingEventHttpLogs,
      payload: {
        isLoading: false
      }
    }),
    call(hideLoading)
  ]);
}

function* watchFetchLogs() {
  yield takeLatest(fetchEventHttpActionLogs, fetchEventHttpActionLogsSaga);
}

export default function* () {
  yield all([
    watchFetchLogs(),
  ]);
}
